import { z } from "zod";

export const defaultLayout = [
  [
    ["summary", "experience", "education", "projects", "volunteer", "mostProudOf", "myMind", "signature"],
    [
      "skills",
      "certifications",
      "languages",
      "references",
      "awards",
      "publications",
      "presentations",
      "interests",
      "hobbies",
    ],
  ],
];

// Schema
export const metadataSchema = z.object({
  schemaVersion: z.string().default("1.0.0"),
  template: z.string().default("leafish"),
  layout: z.array(z.array(z.array(z.string()))).default(defaultLayout), // pages -> columns -> sections
  css: z.object({
    value: z.string().default(""),
    visible: z.boolean().default(false),
  }),
  page: z.object({
    margin: z.number().default(40),
    format: z.enum(["a4", "letter"]).default("a4"),
    options: z.object({
      breakLine: z.boolean().default(false),
      pageNumbers: z.boolean().default(true),
    }),
  }),
  theme: z.object({
    background: z.string().default("#ffffff"),
    text: z.string().default("#000000"),
    primary: z.string().default("#0284c7"),
    isFree: z.string().optional(),
  }),
  typography: z.object({
    font: z.object({
      family: z.string().default("IBM Plex Serif"),
      subset: z.string().default("latin"),
      variants: z.array(z.string()).default(["regular"]),
      size: z.number().default(14.5),
    }),
    bodyFont: z.object({
      family: z.string().default("Open Sans"),
      subset: z.string().default("latin"),
      variants: z.array(z.string()).default(["regular"]),
    }).optional(),
    lineHeight: z.number().default(1.75),
    hideIcons: z.boolean().default(false),
    underlineLinks: z.boolean().default(true),
    headerFontSize: z.number().default(22),
    headerTransform: z.enum(["uppercase", "capitalize", "lowercase", "none"]).default("uppercase"),
  }),
  notes: z.string().default(""),
  /** Filename of the selected resume background image */
  backgroundImage: z.string().default(""),
  /** Custom handwritten signature text */
  signature: z.string().default(""),
  /** Locale/language for the resume */
  locale: z.string().default("en-US"),
  /** Market Context for ATS analysis (Market DNA, Perplexity insights) */
  marketContext: z.any().optional(),
});

// Type
export type Metadata = z.infer<typeof metadataSchema>;

// Defaults
export const defaultMetadata: Metadata = {
  schemaVersion: "1.0.0",
  template: "framed",
  layout: defaultLayout,
  css: {
    value: "",
    visible: false,
  },
  page: {
    margin: 40,
    format: "a4",
    options: {
      breakLine: false,
      pageNumbers: true,
    },
  },
  theme: {
    background: "#ffffff",
    text: "#000000",
    primary: "#1b79db",
    isFree: "NO",
  },
  typography: {
    font: {
      family: "IBM Plex Serif",
      subset: "latin",
      variants: ["regular"],
      size: 14.5,
    },
    bodyFont: {
      family: "Open Sans",
      subset: "latin",
      variants: ["regular"],
    },
    lineHeight: 1.75,
    hideIcons: true,
    underlineLinks: true,
    headerFontSize: 22,
    headerTransform: "uppercase",
  },
  notes: "",
  backgroundImage: "",
  signature: "",
  locale: "en-US",
};
